import { useState } from "react";
import { Button } from "@/components";
import styles from "@/styles/containers/configure.module.scss";

import classNames from "classnames/bind";

import { Alert } from "@/components/Alert";
import { Input } from "@/components/Input";
import { ArrowLeft } from "@/components/Icons";
import { Store } from "@/core/Store";

const css = classNames.bind(styles);

const CODES = {
  /* Coco Bambu - Londrina*/
  1927: "09082364",

  /* Coco Bambu - Del Rey*/
  2175: "09119842"
};

export default function PasswordConfirm({ onConfirm, onBack }) {
  const [password, setPassword] = useState(null);

  const [errorMessage, setErrorMessage] = useState(null);

  const validate = () => {
    const staticPassword = "01020264";

    const storePassword = CODES[Store.id] || staticPassword;

    if (password === storePassword) {
      onConfirm();
    } else {
      setErrorMessage("Senha inválida!");
    }
  };

  return (
    <>
      <div className={styles.configureContainer}>
        <div className={styles.fieldContainer}>
          <p className={styles.title}>Informe a senha</p>

          <div className={styles.enterCode}>
            <Input
              autoFocus
              design="great"
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setErrorMessage(null);
              }}
            />
          </div>

          <div className={styles.footer}>
            <div className="d-flex align-center justify-between w-100">
              <div>
              {onBack && (
                <Button design="secondary"  onClick={onBack}>
                  <ArrowLeft />
                  Voltar
                </Button>
              )}
              </div>

              <div>
                <Button
                  disabled={!password}                
                  onClick={() => {
                    password && validate();
                  }}
                >
                  Confirmar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Alert
        open={!!errorMessage}
        onClose={() => setErrorMessage(null)}
        title={errorMessage}
      />
    </>
  );
}
